/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Out_Reason_AdjustmentInputs */

const vi_pkl_out_reason_adjustment = /** @type {(inputs: Pkl_Out_Reason_AdjustmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều chỉnh`)
};

/**

* @param {Pkl_Out_Reason_AdjustmentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_out_reason_adjustment = /** @type {((inputs?: Pkl_Out_Reason_AdjustmentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Out_Reason_AdjustmentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_out_reason_adjustment(inputs)
});